import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const dateToSearchParams = (date?: Date) => {
  return date?.toISOString()?.split('T')?.[0] ?? '';
};

export const dateMonthsAgo = (date: Date, months: number) => {
  return new Date(date?.setDate(date?.getDate() - Math.abs(months * 30)));
};

export enum DateVariant {
  Dashboard = 'dashboard',
  Information = 'information',
  Table = 'table',
}

export const dateToPrint = (
  date?: string,
  variant = DateVariant.Dashboard,
  time = true,
): string => {
  if (variant === DateVariant.Dashboard) {
    return date
      ? dayjs
          .utc(dayjs(date))
          .local()
          .format(`DD-MM-YYYY${time ? ' HH:mm' : ''}`)
      : '-';
  }

  if (variant === DateVariant.Table) {
    return date
      ? dayjs
          .utc(dayjs(date))
          .local()
          .format(`DD/MM/YYYY${time ? ' HH:mm' : ''}`)
      : '-';
  }

  if (variant === DateVariant.Information) {
    return date
      ? dayjs
          .utc(dayjs(date))
          .local()
          .format(`DD MMM YYYY${time ? ' HH:mm' : ''}`)
      : '-';
  }

  return '-';
};
